import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export default class Campagne {
  constructor() {
    this.init();
    // document.body.style.overflow = "hidden";
    //vars
    this.isAnimating = false;
  }
  init() {
    this.touchDevice();
    this.setHeightCards();
    this.setHeightCardsTitle();
    this.listeners();

    this.observerWave();
    this.observerSectionTitle();
    this.observerFooter();

    this.scrollAnimation(); 

    this.tables();
    this.accessibility();

    // Anims
    this.onPageLoad();

    window.onbeforeunload = function () {
        window.scrollTo({
          top: 0,
          behavior: "instant",
        });
    };
  }

  accessibility() {
    $("*[tabindex], input, a, button").on("focus", function (e) {
      const $element = $(this);
      $(window).keyup((e) => {
        var code = e.keyCode ? e.keyCode : e.which;
        if (code == 9) {
          $("*").removeClass("is-focused");
          $element.addClass("is-focused");
        }
      });
    });
  }

  listeners() {
    window.addEventListener("resize", this.setHeightCards);

    const btnScroll = document.querySelector(".campagne-page__introduction--scrolldown");
    btnScroll.addEventListener("click", this.scrollDown);

    const downloadButtons = document.querySelectorAll(".section-download__title--links");
    downloadButtons.forEach((button) => {
      button.addEventListener("click", this.download);
    });
  }

  download(e) {

    const button = e.target;
    const url = button.getAttribute("href");
    const type = button.getAttribute("data-type");

    console.log(button);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cta_app",
      click_text: 'undefined',
      click_url: url,
      cta_context: type,
    });
  }

  // SET HEIGHT OF CARDS
  setHeightCards() {
    // SET CARDS DESCRIPTION
    const cardsDescription = document.querySelectorAll(".block-title__head--description");
    const section = document.querySelector(".section-titles");

    // reset the height of the cards
    section.style.setProperty("--height-card", `auto`);

    let maxHeight = 0;
    cardsDescription.forEach((card) => {
      if (card.offsetHeight > maxHeight) {
        maxHeight = card.offsetHeight;
      }
    });

    // set variables --height-cart for the height of the cards on section
    section.style.setProperty("--height-card", `${maxHeight}px`);
  }

  setHeightCardsTitle() {
    const cardsTitle = document.querySelectorAll(".block-title__head--title");
    const section = document.querySelector(".section-titles");

    // reset the height of the cards
    section.style.setProperty("--height-card-title", `auto`);

    let maxHeight = 0;
    cardsTitle.forEach((card) => {
      if (card.offsetHeight > maxHeight) {
        maxHeight = card.offsetHeight;
      }
    });

    // set variables --height-cart for the height of the cards on section
    section.style.setProperty("--height-card-title", `${maxHeight}px`);
  }

  tables() {

    this.buttonTable = document.querySelectorAll(".block-title__informations--button");
    this.buttonTable.forEach((button) => {
      button.addEventListener("click", openTable);
      button.addEventListener("keyup", setAccess);

    });

    this.closesTable = document.querySelectorAll(".section-titles__table--close");
    this.closesTable.forEach((close) => {
      close.addEventListener("click", closeTable);
      close.addEventListener("keyup", removeAccess);
    });

  
    function setAccess(e) {
      if (e.keyCode === 13) {
        const button = e.target;
        const idTable = button.getAttribute("data-table");
        const buttonClose = document.querySelector(`#${idTable} .section-titles__table--close`);

        setTimeout(() => {
          buttonClose.focus();
          buttonClose.classList.add("is-focused");
        }, 200);

        window.addEventListener("keydown", disableTab);
      }
    }

    function removeAccess(e) {
      if (e.keyCode === 13) {
        const button = e.target;
        const table = button.closest(".section-titles__table");
        const idTable = table.getAttribute("id");
        const buttonOpen = document.querySelector(`[data-table="${idTable}"]`);

        setTimeout(() => {
          buttonOpen.focus();
          buttonOpen.classList.add("is-focused");
        }, 200);

        window.removeEventListener("keydown", disableTab);
      }
    }

    function disableTab(e){
       if (e.keyCode === 9) {
          e.preventDefault();
       }
    }

    function openTable(e) {
      const button = e.target;
      const idTable = button.getAttribute("data-table");
      const table = document.querySelector(`#${idTable}`);
      const title = button.querySelector("span").textContent;

      table.classList.add("is-active");
      document.body.classList.add("is-active-table");

      document.body.addEventListener("wheel", preventScroll, {
        passive: false,
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "cta_landing",
        click_url: "undefined", // vrai undefined js pas string texte "undefined"
        click_text: title,
        cta_context: idTable === 'table-1' ? '24h' : '3 jours', // i.e "24h" ou "3 jours" si cta titre, "hero" si cta header avec ancre
      });
    }

    function  closeTable(e) {
      const table = e.target.closest(".section-titles__table");
      table.classList.remove("is-active");
      document.body.classList.remove("is-active-table");

      document.body.removeEventListener(
              "wheel",
              preventScroll
      );
    }

    function preventScroll(e) {
      e.preventDefault();
      e.stopPropagation();

      return false;
    }
  }

  scrollDown(e) {
    const position = document.querySelector(".campagne-page__content").offsetTop;
    const title = e.target.querySelector('span').textContent;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cta_landing",
      click_url: "undefined",
      click_text: title,
      cta_context: "hero",
    });

    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
  }

  observerWave() {
    const watch = document.querySelector(".campagne-page__wave");
    const ob = new IntersectionObserver(obCallback, {
      rootMargin: "0px 0px -40% 0px",
    });
    ob.observe(watch);

    function obCallback(payload) {
      if (payload[0].isIntersecting) {
        document.querySelector(".campagne-page__wave").classList.add("disable");
      }
    }
  }

  observerSectionTitle() {
    const watch = document.querySelector(".section-titles");
    const ob = new IntersectionObserver(obCallback, {
      rootMargin: "0px 0px -40% 0px",
    });
    ob.observe(watch);

    function obCallback(payload) {
      if (payload[0].isIntersecting) {
        document.querySelector(".section-titles").classList.add("is-entered");

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "scroll_section_titres",
        });
      }
    }
  }

  observerFooter() {
    const watch = document.querySelector(".section-download__footer");
    const ob = new IntersectionObserver(obCallback, {
      rootMargin: "0px 0px 15% 0px",
    });
    ob.observe(watch);

    function obCallback(payload) {
      if (payload[0].isIntersecting) {
        document.querySelector(".section-download__footer").classList.add("is-entered");

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "scroll_section_chrono",
        });
      }
    }
  }

  onPageLoad() {
    setTimeout(() => {
      document.body.classList.add("is-loaded");
    }, 500);
  }

  scrollAnimation() {
    const introductionElement = document.querySelector(".campagne-page__fix");
    const imageElement = document.querySelector(".campagne-page__biground--round");
    const roundElement = document.querySelector(".campagne-page__biground");

    // if window width is less than 991px
    if (window.innerWidth > 991) {

      // ScrollTop

      ScrollTrigger.create({
        trigger: introductionElement,
        start: "top top",
        pin: true,
        pinSpacing: true,
        onUpdate: (self) => {
          const progress = self.progress.toFixed(2) * 100;

          if (progress < 50) {
            roundElement.classList.remove("is-change");
          }
          if (progress >= 50) {
            roundElement.classList.add("is-change");
          }
        },
      });

    } else {
      // interval roundelement animation every 5s
      setInterval(() => {
        roundElement.classList.toggle("is-change");
      }
      , 5000);
    }
  }

  touchDevice() {
    if (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0)) {

        document.body.classList.add("is-touch");

    }
  }
}
